import { useOne } from "@refinedev/core";
import type { MediaAsset } from "../pages/media/types";

export const useAssetById = <T extends MediaAsset = MediaAsset>({
  assetId,
}: {
  assetId?: string | null;
}) => {
  const shouldFetch = !!assetId;

  const data = useOne<T>({
    resource: "media/media/assets",
    id: assetId!, // we know assetId is not null or undefined because of the enabled condition
    queryOptions: {
      enabled: shouldFetch,
    },
  });

  return data;
};
